import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("session_id");
    if (!sid) { navigate("/carteira"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
      } catch {}
      if (tries < 8) setTimeout(poll, 1500);
      else setStatus("timeout");
    };
    poll();
  }, [navigate]);

  return (
    <div className="dr-grain min-h-screen bg-[#090B0E] flex items-center justify-center p-6">
      <div className="dr-card p-10 max-w-md w-full text-center" data-testid="payment-result">
        {status === "checking" && (<><Loader2 className="animate-spin mx-auto text-[#D4AF37]" size={44} /><p className="mt-4 font-head font-bold text-xl">Confirmando pagamento...</p></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto text-[#10B981]" size={56} /><h1 className="mt-4 font-head font-black text-2xl">Depósito confirmado!</h1><p className="text-[#9CA3AF] mt-2">Seus créditos já estão disponíveis.</p><button onClick={() => navigate("/carteira")} className="btn-gold mt-6 px-6 py-3 rounded-full" data-testid="back-wallet-btn">Ver carteira</button></>)}
        {["failed", "timeout"].includes(status) && (<><p className="font-head font-bold text-xl text-[#EF4444]">Pagamento não confirmado</p><p className="text-[#9CA3AF] mt-2 text-sm">Se o valor foi debitado, os créditos aparecerão em instantes.</p><button onClick={() => navigate("/carteira")} className="btn-gold mt-6 px-6 py-3 rounded-full">Voltar</button></>)}
      </div>
    </div>
  );
}
